import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router';

import { StylesheetContext } from '../../contexts/StylesheetContext';
import { TicketContext } from '../../contexts/TicketContext';
import { SelfServiceError } from '../../helpers/Errors';
import { isTicketCancellable } from '../../helpers/TicketHelpers';
import { TicketRoutePaths } from '../../interfaces/Routes';
import { FCWithChildren } from '../../interfaces/Shared';
import { SupportedErrorTypes } from '../../services/ErrorService';
import { isPathInRoutes } from '../../services/RouteService';
import StepsService from '../../services/StepsService';
import { useAsyncError } from '../Error/useAsyncError';
import { StepsContext } from '../Steps/StepsContext';

export const PageGuard: FCWithChildren = ({ children }) => {
  const { ticket } = useContext(TicketContext);
  const { steps } = useContext(StepsContext);
  const { stylesheet } = useContext(StylesheetContext);
  const { pathname } = useLocation();

  const { throwAsyncError } = useAsyncError();

  const activeStep = StepsService.getActiveStep(steps);

  if (ticket && pathname.includes(`/${TicketRoutePaths.cancel}`) && !isTicketCancellable(ticket, stylesheet)) {
    return <Navigate to={activeStep.uri} />;
  }

  const isExcludedPath = isPathInRoutes(pathname, [TicketRoutePaths.contact, TicketRoutePaths.faq]);

  if (isExcludedPath) {
    return children;
  }

  const attemptedStepIndex = steps.findIndex(step => pathname === step.uri);

  if (ticket) {
    if (steps[attemptedStepIndex]?.isDisabled) {
      return <Navigate replace to={activeStep.uri}/>;
    }
  } else {
    // TODO: consider in the future remove this since ticket must always be present
    throwAsyncError(new SelfServiceError({
      reason: SupportedErrorTypes.ticketNotFound,
    }));
  }

  return children;
};
